export default {
    'name': 'patentPak',
    'label': 'CAS.PatentPak',
    'getComponent': () => import('./PatentPak.vue'),
    'tabIndex': 100,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/cas/patentPak',
};
